import React, { FC } from 'react'
import { ComponentBenefits } from '../../../models/components/benefits'
import { BenefitsContainer } from './style'

//* components
import GlobalContainer from '../globalContainer'
import { Icons, ImageContainer } from './subcomponent'

type Props = {
  data: ComponentBenefits
}

const Benefits: FC<Props> = ({ data }) => {
  if (!data) return null
  const heading = data.headline || ''
  const headlineAlignment = data.headlineAlignment || ''
  const mainImageSrc = data.image?.image?.file?.url || ''
  const mainImageAlt = data.image?.image?.altText || ''

  return (
    <BenefitsContainer data-cy="benefits">
      <GlobalContainer className="Benefits__Inner">
        {mainImageSrc && (
          <ImageContainer
            mainImageSrc={mainImageSrc}
            mainImageAlt={mainImageAlt}
            heading={heading}
          />
        )}

        {data.items && <Icons icons={data.items} />}
      </GlobalContainer>
    </BenefitsContainer>
  )
}

export default Benefits
